import React, {useState} from "react";
import styles from "./VehicleSliderButton.module.css";

export enum SliderButtonPosition {
    BUTTON_LEFT = "BUTTON_LEFT",
    BUTTON_RIGHT = "BUTTON_RIGHT"
}

interface VehicleSliderButtonProps {
    position: SliderButtonPosition
    onClick: () => void
}

export const VehicleSliderButton: React.FC<VehicleSliderButtonProps> = ({
                                                                            position,
                                                                            onClick,
                                                                        }) => {

    const [animate, setAnimate] = useState(false);
    const isLeft = position === SliderButtonPosition.BUTTON_LEFT;

    return (
        <div
            key={position}
            onClick={() => {
                setAnimate(true);
                onClick();
            }}
            className={[
                styles.button,
                isLeft ? styles.left : styles.right,
                animate ? styles.blink : ""
            ].join(" ")}
            onAnimationEnd={() => {
                if (animate) {
                    setAnimate(false);
                }
            }}
        >
            <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M12.5 15.8332L6.66667 9.99984L12.5 4.1665"
                    stroke="black"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        </div>
    );
}
